import { mapGetters } from 'vuex';

export default {
  name: 'ServiceChangeConfirmation',

  props: {
    hasStatusBeenChange: {
      type: Boolean,
      default: false,
    },
    service: {
      type: Object,
      default: (() => {
      }),
    },
    withMoreInformation: {
      type: Boolean,
      default: false,
    },
    number: {
      type: String,
      default: '',
    },
    confirmationRequired: {
      type: Boolean,
      default: false,
    },
    enabled: {
      type: Boolean,
      default: false,
    },
    incorrect_code: {
      type: Boolean,
      default: false,
    },
    activationFailed: {
      type: Boolean,
      default: false,
    },
  },

  data() {
    return {
      x_marker: require("@/assets/x.svg"),
      arrow: require("@/assets/arrow-up.svg"),
      smsCode: null
    };
  },

  computed: {
    ...mapGetters([
      'servicesListLoading',
      'changeStatusLoading',
    ]),
  },
  methods: {
    close() {
      if (this.confirmationRequired) {
        this.$EventBus.$emit('ServiceChangedConfirmation/CANCEL_CONFIRMATION');
        this.$store.commit('CLEAR_SERVICE_STATUS_CONFIRMATION_REQUIRED');
      } else {
        this.$EventBus.$emit('ServiceChangeConfirmation/CLOSE_MODAL');
        this.$store.commit('CLEAR_SERVICE_STATUS_CHANGE_RESULT');
      }
    },
    submit() {
      this.$EventBus.$emit('ServiceChangeConfirmation/CHANGE_STATUS', this.service.uuid, this.service.active && !this.service.rechargeable);
      this.smsCode = '';
    },
    submitConfirmation() {
      if (this.smsCode != '')
        this.$EventBus.$emit('ServiceChangedConfirmation/SUBMIT_CONFIRMATION', this.service.uuid, this.service.active && !this.service.rechargeable, this.smsCode);
    },
  },
};



// WEBPACK FOOTER //
// ./src/components/Modals/ServiceChangeConfirmation/component.js